/*
 * @Author: Michael
 * @Date: 2018-12-14 15:07:58
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-15 21:33:50
 * 和微信相关的函数API
 */

import getUrlParam from './getUrlParam';
import fetch from '@/common/api/fetch';
import CONFIG from "@/common/config";
import store from '@/store';
import getRedirectUrl from '@/common/utils/getRedirectUrl';
import { AxiosPromiseData } from '@/common/interface';
import { SignatureData, ShareObjectInterface } from '@/common/interface';
import getActivityType from './getActivityType';


/**
 * 小程序环境与小程序通信
 * 在小程序环境中打开页面，需将分享的信息通知给小程序，生成分享页面对应的小程序的地址
 * @export
 * @param {string} uid  要交换信息的uid，为需要分享信息的用户的uid
 */
export async function exchangeMsgToXcx(uid: string) {
  if (window.__wxjs_environment === 'miniprogram' && getUrlParam('type') === 'share') {
    const broadcastId: string = (getUrlParam('broadcastId') as string);
    const distributorId: string = (getUrlParam('distributorId') as string);
    const templateType: string = getActivityType();
    let wxShareCover: string = "";
    const param = { activityId: broadcastId };

    let { qrCodeUrl, title, htmUrl, urlUid, content, cover, avatar, nickname, gachaTypeParameter, posterImage, channel='' } = store.state;
    

    if (content) {
       const info = JSON.parse(content);
      cover = info.viewBackground ? cover : info.groupImageList[0];
      wxShareCover = info.viewBackground ? (posterImage ||  gachaTypeParameter.prize.posterImage || gachaTypeParameter.scholarship.posterImage) : info.groupImageList[0];
    }
    if (uid || urlUid) {
      qrCodeUrl = `${qrCodeUrl || htmUrl}&uid=${uid || urlUid}`;
    }
    if( templateType === "distributeType" && distributorId){
      qrCodeUrl = `${qrCodeUrl || htmUrl}&distributorId=${distributorId}`;
    }
    const redirectUrl = getRedirectUrl(qrCodeUrl);
    const query = { broadcastId };
    if (uid && uid !== undefined) {
      (query as any).pUid = uid;
    }
    const shareData = window.location.href.includes('orgId') ? {} : await fetch.post('c/xm/show/getShareId', query);
    fetch.Sales('anon/customerShow/generateSceneTicket', {
      scene: redirectUrl
    }).then((res2: AxiosPromiseData) => {
      window.wx.miniProgram.postMessage({
        data: {
          title,
          cover,
          parentUid: uid,
          broadcastId,
          templateType,
          shareId: shareData.data,
          scene: res2.result,
          avatar,
          nickname,
          wxShareCover,
          channel
        }
      });
    });
  }
}

/**
 * 微信注册图片预览配置
 * 包括拍照和获取本地图片的数据
 * @param signature 微信签名
 */
export function wechatPreviewSignUp(signature: SignatureData): void {
  window.wx.config({
    debug: false,
    appId: signature.appId,
    timestamp: signature.timestamp,
    nonceStr: signature.nonceStr,
    signature: signature.signature,
    jsApiList: [
      'previewImage',
      'chooseImage',
      'getLocalImgData',
      'hideMenuItems',
      'getLocation',
    ],
    openTagList: ['wx-open-subscribe','wx-open-launch-weapp'],
  });
  window.wx.ready(() => {
    window.wx.hideMenuItems({
      menuList: ['menuItem:copyUrl'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    });
  });
}

/**
 * 微信注册
 * @param signature 微信签名
 * @param shareObject 分享配置
 */
export function wechatSignUp(signature: SignatureData, shareObject: ShareObjectInterface): void {
  shareObject['success'] = function () {
    const broadcastId = getUrlParam('broadcastId');
    fetch.post('c/xm/show/incShareNum', { broadcastId });
  }
  console.log(signature, 1);
  window.wx.config({
    debug: false,
    appId: signature.appId,
    timestamp: signature.timestamp,
    nonceStr: signature.nonceStr,
    signature: signature.signature,
    jsApiList: [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZon',
      'previewImage',
      'chooseImage',
      'getLocalImgData',
      'hideMenuItems',
      'getLocation',
    ],
    openTagList: ['wx-open-subscribe','wx-open-launch-weapp'],
  });
  window.wx.ready(() => {
    window.wx.hideMenuItems({
      menuList: ['menuItem:copyUrl', 'menuItem:share:timeline'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    });
    window.wx.onMenuShareQQ(shareObject);
    window.wx.onMenuShareTimeline(shareObject);
    window.wx.onMenuShareAppMessage(shareObject);
    window.wx.onMenuShareQZone(shareObject);
    window.wx.onMenuShareWeibo(shareObject);
    const audio = document.querySelector(".selected-bgm");
    if (audio && !window.playing) {
      (audio as HTMLAudioElement).play();
      window.playing = true;
    }
  });
}
